import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export interface AdminLocation {
  id: string;
  customer_id: string;
  name: string;
  type: string | null;
  address: {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
  } | null;
  contact_name: string | null;
  contact_phone: string | null;
  contact_email: string | null;
  timezone: string | null;
  status: string | null;
  updated_at: string;
  customer: { id: string; name: string } | null;
  deployments: Array<{ id: string; status: string | null }>;
  tickets: Array<{ id: string; status: string | null }>;
}

export function useAllLocations() {
  return useQuery({
    queryKey: ['admin-locations'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('locations')
        .select(`
          id, customer_id, name, type, address,
          contact_name, contact_phone, contact_email,
          timezone, status, updated_at,
          customer:customers!locations_customer_id_fkey(id, name),
          deployments(id, status),
          tickets(id, status)
        `)
        .is('deleted_at', null)
        .order('name');

      if (error) throw error;
      return (data ?? []) as unknown as AdminLocation[];
    },
    staleTime: 60 * 1000,
  });
}
